import { create } from "zustand";

interface CinematicState {
  paused: boolean;
  setPaused: (paused: boolean) => void;
}

export const useCinematicStore = create<CinematicState>((set) => ({
  paused: false,
  setPaused: (paused) => set({ paused }),
}));
